import BaseAPI from "../api";

const path: string = "documents";

export class DocumentsApi extends BaseAPI {
  static list(query: any): Promise<any> {
    return this.api.get(`${path}`, {
      params: { ...query },
    });
  }
}
